<template>
	<div class="dataExpress" :style="{'min-height': windowSizeHeight-140 +'px'}">
		<!-- <h3 class="pageTitle">数据快报</h3> -->
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-home Icon" ></i>
			<span class="header_text">/ 首页</span>
		</div>
		<div class="m-t-10" style="">
			<div class="bankList box-shadow fl m-r-15 " :class="index==0?'bankList1':'bankList2'" v-for="(item,index) in available_balance">
				<div class="clear bran-card-line" >
					<div class="fl">开户名称：{{item.name}}</div>
					<div class="fr"><el-button type="primary transferBtn" round @click="goToFundRecharge">转账充值</el-button></div>
				</div>
				<div class="clear bran-card-line">
					<div class="">开户银行：{{item.channel_name}}</div>
				</div>
				<div class="clear bran-card-line">
					<div class="">专属账号：{{item.bank_account}}</div>
				</div>
				<div class="m-t-30">
					<div class="fl">
						<img class="bank-Logo" src="../assets/img/ws-Logo.svg" >
					</div>
					<div class="fr align-right font-20">
						<div class=""> 账户余额 </div>
						<div class=""> {{item.balance | filterNumber}} </div>
					</div>
				</div>
			</div>
		</div>
		<div class="clear"></div>
		<el-row :gutter="15" class="Module3 ">
			<el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
				<div class="Module3-box m-t-20 box-shadow" >
					<div class="card-header card-header-one ">
						<h4>最近项目</h4>
					</div>
					<div class="Module3-box-oneBox ">
						<div class="block Module3-noe-content">
							<el-timeline>
								<el-timeline-item v-for="(item, index) in projectArr" :key="index" :icon="item.icon" :type="item.type" :color="item.color"
								 :timestamp="item.add_time" placement="top">
									<el-card>
										<p class="p_lineH26">项目：
											<span class="projectName" @click="goToProjectManage">{{item.name}}</span>
										</p>
										<p class="p_lineH26">
											<span>进度：</span>
											<span class="xm-state-0" v-if="item.status=='0'" >要素验证</span>
											<span class="xm-state-1" v-if="item.status=='1'" >待支付</span>
											<span class="xm-state-2" v-if="item.status=='2'" >待报审</span>
											<span class="xm-state-3" v-if="item.status=='3'" >已驳回</span>
											<span class="xm-state-4" v-if="item.status=='4'" >结算异常</span>
											<span class="xm-state-5" v-if="item.status=='5'" >已结算</span>
											<span class="xm-state-6" v-if="item.status=='6'" >审核中</span>
											<span class="xm-state-7" v-if="item.status=='7'" >结算中</span>
											<span class="xm-state-8" v-if="item.status=='8'" >已关闭</span>
											<span class="xm-state-6" v-if="item.status=='9'" >审核中</span>
											<span class="xm-state-10" v-if="item.status=='10'" >签约异常</span>
										</p>
										<p class="p_lineH26">订单量：
											<span class="projectName font-Tahoma" @click="goToOrderList(item.id)">{{item.totality}}</span>
										</p>
										<p class="p_lineH26 font-consolas">订单额：{{item.total_money | filterNumber}} 元</p>
									</el-card>
								</el-timeline-item>
							</el-timeline>
						</div>
					</div>
				</div>
			</el-col>

			<el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
				<div class="Module3-box m-t-20 box-shadow">
					<div class="card-header card-header-three">
						<h4>资金动态</h4>
					</div>
					<div class="Module3-box-twoBox">
						<div class="Module3-three-content" >
							<template>
								<el-table :data="fundDetailArr" >
									<el-table-column type="expand" >
										<template slot-scope="props">
											<el-form label-position="left" inline class="demo-table-expand">
												<p>
													变动金额:
													<span class="font-consolas dd-state-1" v-if=" props.row.change_type == '2'"  >-{{props.row.change_amount | filterNumber}}</span>
													<span class="font-consolas dd-state-0" v-if=" props.row.change_type == '1'"  >{{props.row.change_amount | filterNumber}}</span>
												</p>
												<p>
													账户余额:
													<span class="font-consolas">{{props.row.account_balance | filterNumber}}</span>
												</p>
												<p>
													发生时间:
													<span  class="font-Tahoma">{{props.row.operation_time}}</span>
												</p>
											</el-form>
										</template>
									</el-table-column>
									<el-table-column width="80px">
										<template slot-scope="{row,$index}">
											<span v-if=" row.type=='1'" > 提现 </span>
											<span v-if=" row.type=='2'"> 项目下发 </span>
											<span v-if=" row.type=='3'"> 平台结算 </span>
											<span v-if=" row.type=='4'"> 充值 </span>
										</template>
									</el-table-column>

									<el-table-column align="right">
										<template slot-scope="props">
											<span class="font-consolas dd-state-1" v-if=" props.row.change_type == '2'"  >-{{props.row.change_amount | filterNumber}}</span>
											<span class="font-consolas dd-state-0" v-if=" props.row.change_type == '1'" >+{{props.row.change_amount | filterNumber}}</span>
										</template>
									</el-table-column>

								</el-table>
							</template>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
				<div class="Module3-box p-l-20 p-r-20 p-t-10 p-b-10 m-t-20 box-shadow" @click="goToProjectNew">
					<div class="orderBox" style="height: 100px;">
						<div class="fl orderLeftImg3"></div>
						<div class="fr orderRightBox three">
							<p>批量打款</p>
							<p>批量订单快速到账</p>
						</div>
					</div>
				</div>
				<div class="Module3-box p-l-20 p-r-20 p-t-10 p-b-10 m-t-20 box-shadow" @click="downloadExcle">
					<div class="orderBox" style="height: 100px;">
						<div class="fl orderLeftImg4"></div>
						<div class="fr orderRightBox four">
							<p>模板下载</p>
							<p>批量下发的Excel模板</p>
						</div>
					</div>
				</div>
				<div class="Module3-box m-t-20 box-shadow kuais">
					<div class="card-header card-header-two">
						<h4>快速链接</h4>
					</div>
					<div class="lineBox">
						<ul class="link_box">
							<li class="fl" @click="goToProjectManage">项目列表</li>
							<li class="fl" @click="OrderList">订单列表</li>
							<li class="fl" @click="goToOrderAbnormal">异常订单</li>
							<li class="fl" @click="goToInvoiceList" >发票申请</li>
							<li class="fl" @click="goToFundInfo">交易明细</li>
							<li class="fl" @click="goToFundRecharge">专属账户</li>
							<li class="fl" @click="goToCompanyInfo">企业信息</li>
							<li class="fl" @click="goToUserPassword" style="margin-bottom:20px">账号密码</li>
						</ul>
						<div class="clear"></div>
					</div>
				</div>
			</el-col>

		</el-row>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	export default {
		name: 'dataExpress',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
				available_balance:[],		//账户余额
				projectArr: [], // 项目集合、
				fundDetailArr:[],	//资金流水集合
				companyBankObj:{}, //支付详情
				channelListShow:false, //支付通道

			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { //是否登录
					window.location = 'login.html';
					return;
				}
				this.getBalance(); //获取余额
				this.getProjectList(); //获取项目列表
				this.getMoneyDetail();//获取资金流水明细
				// this.getMessage(); //获取支付通道详情
			},
			getBalance(){ //获取账户余额
				this.$http.post(this.url + '/zhongfy/company/getPayChannelList').then((res) => {
					let data = res.data;
					if (data.code == '200') {
						this.available_balance = data.data;
						this.channelListShow = true;
						console.log(this.available_balance);
					} else if (data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						return;
					}
				}, (err) => {
					return;
				});
			},
			getProjectList() { //获取项目列表
				let fn = new FormData();
				fn.append('page', 1); //页码
				fn.append('page_size', 20); //多少行
				this.$http.post(this.url + '/zhongfy/company/ProjectList', fn).then((res) => {
					if (res.data.code == '200' || res.data.msg == '成功') {
						let data = res.data.data;

						this.projectArr = res.data.data.list

						for(let i= 0 ; i < this.projectArr.length ; i++){
							if(this.projectArr[i].status=='1'){
								let key = 'color'
								let value = '#ffa117'
								this.projectArr[i][key]=value;
							}else if(this.projectArr[i].status=='2'){
								let key = 'color'
								let value = '#6777ef'
								this.projectArr[i][key]=value;
							}else if(this.projectArr[i].status=='3'){
								let key = 'color'
								let value = '#ea5455'
								this.projectArr[i][key]=value;
							}else if(this.projectArr[i].status=='4'){
								let key = 'color'
								let value = '#D0121B'
								this.projectArr[i][key]=value;
							}else if(this.projectArr[i].status=='5'){
								let key = 'color'
								let value = '#3dc9b3'
								this.projectArr[i][key]=value;
							}else if(this.projectArr[i].status=='6'){
								let key = 'color'
								let value = '#2C4198'
								this.projectArr[i][key]=value;
							}else if(this.projectArr[i].status=='7'){
								let key = 'color'
								let value = '#3a54e2'
								this.projectArr[i][key]=value;
							}
						}

					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						return;
					}
				}, (res) => {
					this.$message.error('网络错误');
				})
			},
			getMoneyDetail(){ //获取流水明细
				let fn = new FormData();
				// fn.append('page', 1); //文件
				// fn.append('channel_id', 2); //页码
				this.$http.post(this.url + '/zhongfy/bank/MoneyDetail').then((res) => {
					console.log(res);
					let data = res.data;
					if (data.code == '200' || data.msg == '成功') {
						this.fundDetailArr = data.data.list;
						for(let i = 0 ; i < this.fundDetailArr.length ; i++){
							this.fundDetailArr[i].change_amount = Number(this.fundDetailArr[i].change_amount).toFixed(2);
							this.fundDetailArr[i].account_balance = Number(this.fundDetailArr[i].account_balance).toFixed(2);
						}
					} else if (data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						return;
					}
				}, (err) => {
					this.$message.error('网络错误');
					return;
				});
			},
			goToFundInfo(){  //交易明细
				this.$router.push('/fundInfo');
			},
			goToFundRecharge(){ //专属账户
				this.$router.push('/fundRecharge');
			},
			goToProjectNew(){
				this.$router.push('/projectNew');
			},
			downloadExcle(){ //下载模板
				window.location.href = this.url+'/zhongfy/download';
			},
			goToProjectManage(){
				this.$router.push('/projectManage');
			},
			goToOrderList(id){
				this.$router.push({
					path: '/orderList',
					query: {
						id: id
					}
				})
			},
			OrderList(){
				this.$router.push('/orderList');
			},
			goToOrderAbnormal(){
				this.$router.push('/orderAbnormal');
			},
			goToInvoiceList(){
				this.$router.push('/invoiceList');
			},
			goToCompanyInfo(){
				this.$router.push('/companyInfo');
			},
			goToUserPassword(){
				this.$router.push('/userPassword');
			}

		},
		filters: {

		}
	}
</script>

<style scoped>
	.el-col {
		border-radius: 5px;
	}

	.grid-content {
		border-radius: 5px;
		height: 100px;
		margin-top: 15px;
		padding: 15px 15px 0 15px;
		background: #FFFFFF;
		cursor: pointer;
	}

	.orderBox div:nth-child(1) {
		width: 30%;
		height: 80px;
	}
	.orderBox div:nth-child(2) {
		width: 70%;
		height: 80px;
	}
  .orderBox:hover{
    cursor:pointer 
  }
	.orderLeftImg1 {
		background: url('../assets/img/jinqian.svg') 5px center no-repeat;
		background-size: auto 75%;
	}

	.orderLeftImg2 {
		background: url('../assets/img/chongzhi.svg') 5px center no-repeat;
		background-size: auto 75%;
	}

	.orderLeftImg3 {
		background: url('../assets/img/dakuan.svg') 5px center no-repeat;
		background-size: auto 75%;
	}

	.orderLeftImg4 {
		background: url('../assets/img/xlsx.svg') 5px center no-repeat;
		background-size: auto 75%;
	}


	.orderRightBox {
		text-align: right;
	}

	.orderRightBox p:nth-child(1) {
		font-size: 20px;
		line-height: 45px;
		font-weight: bold;
		color: var(--theme-black);
	}
	.orderRightBox p:nth-child(2) {
		line-height: 40px;
		font-size: 14px;
	}

	.orderBox .one p:nth-child(2){
		color: var(--theme-red);
		font-size: 22px;
		font-weight: bold;
		overflow: hidden;
		font-family: 'Impact', sans-serif;
	}

	.orderBox .tow p:nth-child(2){
		color: var(--theme-green);
		font-weight: 600;
	}

	.orderBox .three p:nth-child(2){
		color: var(--theme-btn);
		font-weight: 600;
	}

	.orderBox .four p:nth-child(2){
		color: var(--theme-green);
		font-weight: 600;
	}
	.lineBox{
		height: 196px;
	}
	.link_box{
		padding: 10px 0 20px 10px;
	}

	.link_box li{
		width: 28%;
		height: 280%;
		line-height: 280%;
		text-align: center;
		border: 1px solid #dddfe5;
		background-color: #f5f6fa;
		color: #333333;
		margin: 8px 2%;
		border-radius: 5px;
		cursor: pointer;
		font-size: 14px;
	}
	.link_box li:nth-last-child{
		padding-bottom: 20px;
	}
	.link_box li:hover{
		background-color: #00afd7;
		border: 1px solid #00afd7;
		color:#FFFFFF;
	}

	.card-header {
		border-bottom: 1px solid #E8E8E8;
		line-height: 30px;
		-ms-grid-row-align: center;
		align-self: center;
		padding: 10px 25px;
		display: flex;
		align-items: center;
	}

	.card-header h4 {
		font-size: 17px;
		line-height: 28px;
		padding-right: 10px;
		margin-bottom: 0;
		color: #212529;
	}

	.rechargeMoney {
		height: 160px;
		background-color: #cccccc;
		border-radius: 5px;
		padding: 15px;
		color: #FFFFFF;
		background-image: linear-gradient(to right, #4f55c9, #888bdc);
	}

	.orderSum {
		height: 160px;
		background-color: green;
		margin-top: 15px;
		border-radius: 5px;
		padding: 15px;
		color: #FFFFFF;
		background-image: linear-gradient(to right, #2e9aed, #498ec1);
	}

	.flex-container-baobiao {
		display: -webkit-flex;
		display: flex;
		height: 100px;
		justify-content: center;
		padding-top: 20px;
	}

	.flex-baobiao-item {
		width: 140px;
		height: 100px;
		margin: 0 20px;

	}

	.flex-baobiao-item h5 {
		text-align: center;
		font-weight: 700;
		color: #6c757d;
		line-height: 24px;
		font-size: 1.25rem;
	}

	.flex-baobiao-item p {
		text-align: center;
		font-weight: 500;
		color: #98a6ad;
		line-height: 33px;
		font-size: 14px;
	}

	/* .Module3 {
		height: 510px;
	} */

	.Module3 .Module3-box {
		background: #FFFFFF;
		border-radius: 5px;
	}
	.Module3 .p_lineH26{
		line-height: 26px;
	}
	.Module3 .projectName{
		cursor: pointer;
		color:#3a54e2;
	}
	.Module3 .projectName:hover{
		text-decoration: underline;
	}

	.Module3-box-oneBox {
		padding: 15px 20px;

	}

	.Module3-box-twoBox{
		padding: 0 20px 15px 20px;
	}


	.Module3-noe-content,.Module3-two-content{
		padding-left: 5px;
		height: 541px;
		overflow: hidden;
	}
	.Module3-three-content {
		height: 556px;
		padding-left: 5px;
		overflow: hidden;
	}

	.Module3-noe-content:hover,
	.Module3-two-content:hover,
	.Module3-three-content:hover {
		overflow: auto;
	}
	.Module3-box-title{
		line-height:40px;
		font-size:14px;
	}
	.Module3-box-title span{
		color:#666666;
	}
	.kuais{height: 340px;}

	.demo-table-expand p{height:26px;}

	.hint_text li {
		line-height: 28px;
		font-size: 14px;
		color: #666666;
		list-style: inside;
	}
	.bankList{
		color: #FFFFFF;
		width: 370px;
		height: 200px;
		padding: 20px;
		border-radius: 10px;
		font-size: 14px;
	}

	.bankList1{
		background-image:linear-gradient(125deg,#00bfbf,#008080);
	}
	.bankList2{
		background-image:linear-gradient(125deg,#02a7f0,#027db4);
	}
	.bran-card-line{height: 30px; line-height: 30px;}

	.transferBtn{
		background-color: #FFFFFF;
		border: 1px solid #008080;
		color: #008080;
		width: 80px;
		height:30px;
		line-height: 30px;
		padding: 0;
		box-shadow: 0px 2px 5px rgba(172, 181, 246, 1);
	}

	.bank-Logo{width: 180px;}

	@media (max-width:1400.78px) {
		.hint_text li {
			line-height: 22px;
			font-size: 12px;
		}
		.Module3-box-title{
			font-size:12px;
		}
		.orderBox .one p:nth-child(2){
			font-size: 15px;
		}
		.orderLeftImg1,.orderLeftImg2,.orderLeftImg3,.orderLeftImg4 {
			background-size: auto 55%;
		}

	}
	@media (max-width:1200.78px) {
		.hint_text li {
			line-height: 28px;
			font-size: 14px;
		}
		.Module3-box-title{
			font-size:14px;
		}
		.orderBox .one p:nth-child(2){
			font-size: 22px;
		}
		.orderLeftImg1,.orderLeftImg2,.orderLeftImg3,.orderLeftImg4 {
			background-size: auto 75%;
		}

	}

</style>



// WEBPACK FOOTER //
// src/components/DataExpress.vue